export class SnapshotRecipeRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "order",
            "baseName": "order",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "op",
            "baseName": "op",
            "type": "SnapshotRecipeRuleOp",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "recursive",
            "baseName": "recursive",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sourceSnapshotId",
            "baseName": "sourceSnapshotId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeRule.attributeTypeMap;
    }
    constructor() {
    }
}
